import {createContext, useEffect, useState} from "react";
import { AuthType } from "../modules/oauth/types/AuthType";
import {AuthContextType} from "../types/AuthContextType";
import {AuthSetInitialState} from "../modules/oauth/login/hooks/AuthSetInitialState";
import api from "../app/api";
import useGetCurrentUser from "../modules/oauth/login/hooks/useGetCurrentUser";
import useGetCurrentUserPermissions from "../modules/oauth/login/hooks/useGetCurrentUserPermissions";
import { PermissionsSetInitialState } from "../modules/oauth/login/hooks/PermissionsSetInitialState";
import {RolesSetInitialState} from "../modules/oauth/login/hooks/RolesSetInitialState";
import useGetCurrentUserRoles from "../modules/oauth/login/hooks/useGetCurrentUserRoles";
import {apiCheckIfAccessTokenActive} from "../modules/oauth/login/hooks/fetcher";

const AuthContext = createContext<Partial<AuthContextType>>({});

// @ts-ignore
export const AuthDataProvider = ({ children }) => {
    const [auth, setAuth] = useState<AuthType>(AuthSetInitialState);
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
    const [permissions, setPermissions] = useState<any>(PermissionsSetInitialState);
    const [roles, setRoles] = useState<any>(RolesSetInitialState);
    const { handleGetCurrentUser } = useGetCurrentUser(setAuth, auth);
    const { handleGetCurrentUserPermissions } = useGetCurrentUserPermissions(setPermissions);
    const { handleGetCurrentUserRoles } = useGetCurrentUserRoles(setRoles);

    const resetPassword = () => {

    }

    useEffect(() => {
        if(auth.initialState) {
            // Check if saved access token is
            if(auth?.accessToken != null && auth?.accessToken != '') {
                setIsLoggedIn(true);
                api.defaults.headers.common['Authorization'] = 'Bearer '+ auth?.accessToken;

                apiCheckIfAccessTokenActive()
                    .then((data) => {

                        handleGetCurrentUser();
                        handleGetCurrentUserPermissions();
                        handleGetCurrentUserRoles();
                    })
                    .catch((response) => {
                        let newState = {
                            currentUser: null,
                            accessToken: null,
                            initialState: false
                        };

                        localStorage.setItem("auth", JSON.stringify(newState));
                        setAuth(newState);
                        setRoles([]);
                        setPermissions([]);
                    });
            }
        }
        else {
            localStorage.setItem("auth", JSON.stringify(auth));

            if(auth?.accessToken != null && auth?.accessToken != '') {
                setIsLoggedIn(true);
                api.defaults.headers.common['Authorization'] = 'Bearer '+ auth?.accessToken;

                // If Access Token is received, receive current user
                if(auth?.currentUser == null) {
                    handleGetCurrentUser();
                    handleGetCurrentUserPermissions();
                    handleGetCurrentUserRoles();
                }
            }
        }

    }, [auth]);

    useEffect(() => {
        localStorage.setItem("permissions", JSON.stringify(permissions));
    }, [permissions]);

    useEffect(() => {
        localStorage.setItem("roles", JSON.stringify(roles));
    }, [roles]);

    return (
        <AuthContext.Provider value={{ auth, setAuth, permissions, setPermissions, roles, setRoles, isLoggedIn, setIsLoggedIn, resetPassword }}>
            { children }
        </AuthContext.Provider>
    );
}

export default AuthContext;